import i18next from 'i18next';
import OrdersLogo from '../../../../../components/Shared/Icons/OrdersLogo';
import permissions from '../../../../permissions';
import Reportables from '../../../../../components/Reportable/List';

// const REPORTABLE_ROUTE_LIST_DS = {
//   path: '/:currentAccountUuid/accounts/:accountUuid/reportables',
//   exact: true,
//   additional: {
//     component: Reportables,
//     protected: true,
//     title: i18next.t('titles:reportables'),
//     icon: OrdersLogo,
//     permission: permissions.CLAIM_REPORTS_GET,
//   },
// };

const REPORTABLE_ROUTE_LIST = {
  path: '/:currentAccountUuid/reportables',
  exact: true,
  additional: {
    component: Reportables,
    protected: true,
    title: i18next.t('titles:reportables'),
    icon: OrdersLogo,
    permission: permissions.CLAIM_REPORTS_GET,
  },
};

export const REPORTABLE_ROUTES = {
  // ------- For child accounts ------
  // listDS: REPORTABLE_ROUTE_LIST_DS,

  // ------- For current accounts ------
  list: REPORTABLE_ROUTE_LIST,
};

